import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=69e042e4&"
import script from "./BaseTextArea.vue?vue&type=script&lang=js&"
export * from "./BaseTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e042e4')) {
      api.createRecord('69e042e4', component.options)
    } else {
      api.reload('69e042e4', component.options)
    }
    module.hot.accept("./BaseTextArea.vue?vue&type=template&id=69e042e4&", function () {
      api.rerender('69e042e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTextArea.vue"
export default component.exports